// Package imports
import React, { useRef, useState } from 'react';
import EmailEditor, { EditorRef } from 'react-email-editor';

// CSS imports
import './CreateEmailTemplate.css';

// Component imports
import TextInput from '../../components/inputs/textInput/TextInput';
import PrimaryButton from '../../components/buttons/primaryButton/PrimaryButton';
import FullPageSpinner from '../../components/fullPageSpinner/FullPageSpinner';
import Alert from '../../components/alert/Alert';

// Helper imports
import SectionWrapper from '../../helpers/components/sectionWrapper/SectionWrapper';

// Service imports
import { ApiService } from '../../services/ApiService';

// Icon imports
import { MdError } from 'react-icons/md';

// Type imports
import { AlertSize } from '../../types/alert/AlertSize';
import { useNavigate } from 'react-router-dom';

const CreateEmailTemplate: React.FC = () => {
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [showUnknownError, setShowUnknownError] = useState(false);

  const emailEditorRef = useRef<EditorRef>(null);
  const navigate = useNavigate();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.target.name) {
      case 'name': {
        setNameError('');
        setName(e.target.value);
        break;
      }
    }
  };

  const triggerSave = () => {
    const isValid = checkInputs();

    if (isValid) {
      save();
    }
  };

  const save = async () => {
    const unlayer = emailEditorRef.current?.editor;

    unlayer?.exportHtml(async (data) => {
      const { design, html } = data;
      setIsLoading(true);

      const res: string | null = await ApiService.createEmailTemplate(
        name,
        html,
        design
      );

      if (res) {
        navigate('/email-templates');
      } else {
        setShowUnknownError(true);
      }
    });
  };

  const checkInputs = () => {
    let isValid = true;

    if (name === '') {
      setNameError('Please enter a name');
      isValid = false;
    }

    return isValid;
  };
  return (
    <div className='CreateEmailTemplate'>
      <SectionWrapper>
        <div className='content'>
          <h2>Create Template</h2>
          <div className='save-button-container'>
            <PrimaryButton label='Save' onClick={triggerSave} />
          </div>
          <TextInput
            value={name}
            name='name'
            label='Name'
            onChange={onChange}
            errorMessage={nameError}
            className='name-input'
          />
          <EmailEditor ref={emailEditorRef} />
        </div>
      </SectionWrapper>
      {isLoading ? <FullPageSpinner /> : null}
      <Alert
        showAlert={showUnknownError}
        size={AlertSize.SMALL}
        time={3000}
        setShowAlert={setShowUnknownError}
      >
        <MdError size={20} />
        <span>Something went wrong!</span>
      </Alert>
    </div>
  );
};

export default CreateEmailTemplate;
